import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { Button } from '@gem/ui-kit';
import { getMascotImageSrc } from '@gem/utils';

import { greetingCardAnalytics } from 'APP/packages/analytics/analytics';

import styles from './GreetingCardBanner.styles.m.css';

export const GreetingCardBanner: FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.appInfo}>
        <img
          src={getMascotImageSrc('logo.svg')}
          className={styles.logo}
          alt={PROJECT_CONFIG.projectName}
        />
        <div className={styles.descriptions}>
          <h4 className={styles.appTitle}>{t('common_title')}</h4>
          <p className={styles.description}>{t('common_description')}</p>
        </div>
      </div>
      <Button
        onClick={(): void => {
          greetingCardAnalytics.trackTapBanner();
          const href = `${PROJECT_CONFIG.deeplinkHost}/invite/cardsbot`;
          window.open(href, '_blank');
        }}
        theme="primary"
        size="0"
      >
        {t('common_view')}
      </Button>
    </div>
  );
};
